import { GET_SURVEY_REVIEW, GET_GOOGLE_REVIEW, GET_REVIEW_LIST, GET_REVIEW_REPORT, GET_STAFF_RATING_LIST,
    GET_ALL_REVIEW_LIST, GET_GOCHECKIN_REVIEW_LIST, GET_YELP_REVIEW_LIST, GET_GOOGLE_REVIEW_LIST ,GET_SYSTEM_MESSAGE, GET_STAFF_RATING_ANSWER, GET_DEVICE_LIST} from "./reviewListTypes";
// import { URL_GET_SURVEY_REVIEW } from "./reviewListUrls";
import { ReviewItem } from "../../models/review/review_item";
import { ReviewReport } from "../../models/review/review_report";

export default {
    [GET_SURVEY_REVIEW](state, data) {
        state.surveyReview = data;
    },
    [GET_GOOGLE_REVIEW](state, data) {
        state.googleReview = data;
    },
    [GET_STAFF_RATING_ANSWER](state, data) {
        state.staffRatingAnswerList = data;
    },
    [GET_REVIEW_LIST](state, data) {
        state.reviewData = data;
        let review_arr = [];
        for(let i = 0; i < data.items.length; i++) {
            review_arr.push(new ReviewItem(data.items[i]));
        }
        state.reviewList = review_arr;
    },
    [GET_REVIEW_REPORT](state, data) {
        state.reviewReport = data ? new ReviewReport(data): null;
    },
    [GET_ALL_REVIEW_LIST](state, data) {
        state.allReviewListData = data;
    },
    [GET_GOCHECKIN_REVIEW_LIST](state, data) {
        state.gocheckinReviewListData = data;
    },
    [GET_YELP_REVIEW_LIST](state, data) {
        state.yelpReviewListData = data;
    },
    [GET_GOOGLE_REVIEW_LIST](state, data) {
        state.googleReviewListData = data;
    },
    [GET_SYSTEM_MESSAGE](state, data) {
      state.messageListData = data;
    },
    [GET_STAFF_RATING_LIST](state, data){
      state.staffRatingList = data;
    },
    [GET_DEVICE_LIST](state, data) {
        state.deviceList = data;
    }
}
